function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".trees_svg__st2{opacity:.1;enable-background:new}.trees_svg__st3{fill:#d0cde1}.trees_svg__st4{fill:#819ad0}");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 652.4,
  cy: 69.9,
  r: 69.9,
  fill: "#ff6584"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M443.8 455.3c-2.8-1.8-5.5-3.8-8.1-5.7-5.2-3.9-10.2-8-14.9-12.4-29.9-27.5-49.4-62.5-66.4-96.6-4.1-8.3-8.1-16.5-12.1-24.6-18.1-37-35.6-70.6-63.4-89.8-15.3-10.5-33.7-16.7-57-16.7-93.9 0-174.2 64.7-206.6 156.1-2.7 7.5-5 15.1-7 23-.7 2.7-1.3 5.4-1.9 8.2-4.2 19.3-6.4 39-6.4 58.7C0 586 93.5 673.3 207.9 698.7c4.6 1 9.3 1.9 14 2.8 229.8 40.2 373.9 38.4 416.9-2.8 43.5-41.9-16.3-123.8-195-243.4z",
  fill: "#3a445c"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "trees_svg__st2",
  cx: 190.6,
  cy: 397.3,
  rx: 89.1,
  ry: 15.1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "trees_svg__st3",
  d: "M308.2 224.4s4.1 63.9-32.1 111.3-99.3 60.1-99.3 60.1-4.1-63.9 32.1-111.3 99.3-60.1 99.3-60.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "trees_svg__st4",
  d: "M203.7 182.9s-47.7 43-54.5 102.2c-6.8 59.2 29.2 112.2 29.2 112.2s47.7-43 54.5-102.2c7-59.2-29.2-112.2-29.2-112.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "trees_svg__st2",
  cx: 384.6,
  cy: 625.7,
  rx: 108.8,
  ry: 18.4
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "trees_svg__st3",
  d: "M375.7 483.4s32.3 27.8 38.1 67.1-17.5 75.1-17.5 75.1-32.3-27.8-38.1-67.1c-5.6-39.4 17.5-75.1 17.5-75.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "trees_svg__st4",
  d: "M307.6 513.8s-1.7 42.6 23.1 73.6c24.8 31 66.9 38.3 66.9 38.3s1.7-42.6-23.1-73.6c-24.8-31-66.9-38.3-66.9-38.3z"
});

function SvgTrees(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trees_svg__f8d7d8f4-b875-4767-a598-99b9608f6632",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 722.3 730.6",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMCIgaWQ9ImY4ZDdkOGY0LWI4NzUtNDc2Ny1hNTk4LTk5Yjk2MDhmNjYzMiIKCSB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDcyMi4zIDczMC42IgoJIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDcyMi4zIDczMC42OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZGNjU4NDt9Cgkuc3Qxe2ZpbGw6IzNBNDQ1Qzt9Cgkuc3Qye29wYWNpdHk6MC4xO2VuYWJsZS1iYWNrZ3JvdW5kOm5ldyAgICA7fQoJLnN0M3tmaWxsOiNEMENERTE7fQoJLnN0NHtmaWxsOiM4MTlBRDA7fQo8L3N0eWxlPgo8dGl0bGU+ZHJlYW1fd29ybGQ8L3RpdGxlPgo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI2NTIuNCIgY3k9IjY5LjkiIHI9IjY5LjkiLz4KPHBhdGggY2xhc3M9InN0MSIgZD0iTTQ0My44LDQ1NS4zYy0yLjgtMS44LTUuNS0zLjgtOC4xLTUuN2MtNS4yLTMuOS0xMC4yLTgtMTQuOS0xMi40Yy0yOS45LTI3LjUtNDkuNC02Mi41LTY2LjQtOTYuNgoJYy00LjEtOC4zLTguMS0xNi41LTEyLjEtMjQuNmMtMTguMS0zNy0zNS42LTcwLjYtNjMuNC04OS44bDAsMGMtMTUuMy0xMC41LTMzLjctMTYuNy01Ny0xNi43Yy05My45LDAtMTc0LjIsNjQuNy0yMDYuNiwxNTYuMQoJYy0yLjcsNy41LTUsMTUuMS03LDIzYy0wLjcsMi43LTEuMyw1LjQtMS45LDguMmMtNC4yLDE5LjMtNi40LDM5LTYuNCw1OC43QzAsNTg2LDkzLjUsNjczLjMsMjA3LjksNjk4LjdjNC42LDEsOS4zLDEuOSwxNCwyLjgKCWMyMjkuOCw0MC4yLDM3My45LDM4LjQsNDE2LjktMi44QzY4Mi4zLDY1Ni44LDYyMi41LDU3NC45LDQ0My44LDQ1NS4zeiIvPgo8ZWxsaXBzZSBjbGFzcz0ic3QyIiBjeD0iMTkwLjYiIGN5PSIzOTcuMyIgcng9Ijg5LjEiIHJ5PSIxNS4xIi8+CjxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0zMDguMiwyMjQuNGMwLDAsNC4xLDYzLjktMzIuMSwxMTEuM2MtMzYuMiw0Ny40LTk5LjMsNjAuMS05OS4zLDYwLjFzLTQuMS02My45LDMyLjEtMTExLjMKCVMzMDguMiwyMjQuNCwzMDguMiwyMjQuNHoiLz4KPHBhdGggY2xhc3M9InN0NCIgZD0iTTIwMy43LDE4Mi45YzAsMC00Ny43LDQzLTU0LjUsMTAyLjJjLTYuOCw1OS4yLDI5LjIsMTEyLjIsMjkuMiwxMTIuMnM0Ny43LTQzLDU0LjUtMTAyLjIKCUMyMzkuOSwyMzUuOSwyMDMuNywxODIuOSwyMDMuNywxODIuOXoiLz4KPGVsbGlwc2UgY2xhc3M9InN0MiIgY3g9IjM4NC42IiBjeT0iNjI1LjciIHJ4PSIxMDguOCIgcnk9IjE4LjQiLz4KPHBhdGggY2xhc3M9InN0MyIgZD0iTTM3NS43LDQ4My40YzAsMCwzMi4zLDI3LjgsMzguMSw2Ny4xcy0xNy41LDc1LjEtMTcuNSw3NS4xcy0zMi4zLTI3LjgtMzguMS02Ny4xCglDMzUyLjYsNTE5LjEsMzc1LjcsNDgzLjQsMzc1LjcsNDgzLjR6Ii8+CjxwYXRoIGNsYXNzPSJzdDQiIGQ9Ik0zMDcuNiw1MTMuOGMwLDAtMS43LDQyLjYsMjMuMSw3My42YzI0LjgsMzEsNjYuOSwzOC4zLDY2LjksMzguM3MxLjctNDIuNi0yMy4xLTczLjYKCUMzNDkuNyw1MjEuMSwzMDcuNiw1MTMuOCwzMDcuNiw1MTMuOHoiLz4KPC9zdmc+Cg==";
export { SvgTrees as ReactComponent };